export const FeaturedCountries = [
  'at',
  'be',
  'fi',
  'de',
  'is',
  'it',
  'nl',
  'es',
];
